"use client";

import { useRouter } from 'next/navigation';
import { usePathname } from 'next/navigation';
import { useTranslations } from 'next-intl';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Globe } from 'lucide-react';

export function LanguageSwitcher() {
  const router = useRouter();
  const pathname = usePathname();
  const t = useTranslations('layout.navbar');

  const switchLanguage = (newLocale: string) => {
    // Extract current locale from pathname
    const currentLocale = pathname.split('/')[1];
    
    // Replace current locale with new locale
    const newPathname = pathname.replace(`/${currentLocale}`, `/${newLocale}`);
    
    // Navigate to new path
    router.push(newPathname);
  };

  // Get current locale from pathname
  const currentLocale = pathname.split('/')[1] || 'sv';

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button 
          variant="ghost" 
          size="icon"
          className="rounded-full w-9 h-9 hover:bg-gray-100 dark:hover:bg-gray-800"
          aria-label={t('language')}
        >
          <Globe className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem 
          onClick={() => switchLanguage('sv')}
          className={currentLocale === 'sv' ? 'bg-gray-100 dark:bg-gray-800' : ''}
        >
          🇸🇪 Svenska
        </DropdownMenuItem>
        <DropdownMenuItem 
          onClick={() => switchLanguage('en')}
          className={currentLocale === 'en' ? 'bg-gray-100 dark:bg-gray-800' : ''}
        >
          🇺🇸 English
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}